import { render, staticRenderFns } from "./SortHeader.vue?vue&type=template&id=7ba50d31&"
import script from "./SortHeader.vue?vue&type=script&lang=ts&"
export * from "./SortHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports